<template>
  <section class="report-chart-card" :class="{ 'report-chart-card--tall': tall }">
    <header class="report-chart-card__header">
      <div>
        <h3>{{ title }}</h3>
        <p v-if="subtitle">{{ subtitle }}</p>
      </div>
      <i v-if="info" class="pi pi-info-circle" v-tooltip.left="info"></i>
    </header>
    <div v-if="loading" class="report-chart-card__state">
      <i class="pi pi-spin pi-spinner"></i><span>A carregar dados...</span>
    </div>
    <div v-else-if="error" class="report-chart-card__state" role="alert">
      <i class="pi pi-exclamation-triangle"></i><span>{{ error }}</span>
    </div>
    <div v-else-if="empty === true || (empty === null && !hasData)" class="report-chart-card__state report-chart-card__state--empty">
      <i class="pi pi-chart-bar"></i><span>Sem dados para os filtros selecionados</span>
    </div>
    <VChart v-else class="report-chart" :option="option" autoresize />
    <slot></slot>
  </section>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, GaugeChart, LineChart, PieChart } from "echarts/charts";
import {
  DataZoomComponent,
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  GaugeChart,
  LineChart,
  PieChart,
  DataZoomComponent,
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
]);

export default {
  name: "ReportEchartCard",
  components: { VChart },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    option: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    empty: { type: Boolean, default: null },
    error: { type: String, default: "" },
    tall: { type: Boolean, default: false },
    info: { type: String, default: "" },
  },
  computed: {
    hasData() {
      if (this.option.dataset) return Boolean(this.option.dataset.source && this.option.dataset.source.length);
      return (this.option.series || []).some((series) => (series.data || []).some((item) => {
        const value = item && typeof item === "object" ? item.value : item;
        return value !== null && value !== undefined && (series.type === "gauge" || Number(value) !== 0);
      }));
    },
  },
};
</script>

<style scoped>
.report-chart-card { min-height: 410px; height: 100%; border: 1px solid #e4e7ec; border-radius: 13px; background: #fff; padding: 1.15rem; box-shadow: 0 5px 18px rgba(16, 24, 40, 0.055); }
.report-chart-card--tall { min-height: 520px; }
.report-chart-card__header { display: flex; justify-content: space-between; gap: 1rem; min-height: 54px; margin-bottom: 0.5rem; }
.report-chart-card__header h3 { margin: 0; color: #1d2939; font-size: 1.05rem; }
.report-chart-card__header p { margin: 0.3rem 0 0; color: #667085; font-size: 0.8rem; }
.report-chart-card__header > i { color: #98a2b3; cursor: help; }
.report-chart { width: 100%; height: 325px; }
.report-chart-card--tall .report-chart { height: 425px; }
.report-chart-card__state { height: 325px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.65rem; color: #667085; }
.report-chart-card__state i { font-size: 1.7rem; color: #0f6f78; }
.report-chart-card__state--empty i { color: #b3bac5; }
</style>
